import React from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import EngageHomepage from "./Engage/EngageHomepage";
import RankPredictorHomePage from "./RankPredictor/RankPredictorHomePage";
import EngageProfile from "./Engage/EngageProfile/EngageProfile";
import XpPointsInfoModal from "./Engage/EngageProfile/XpPointsInfoModal";
import DailyGoalModal from "./Engage/EngageProfile/DailyGoalModal";
import EngageHomepageHeader from "./Engage/EngageHomepageHeader";
import { url_8, url_293, url_294 } from "../../custom_utilities/api_services";
import "./Engage/EngageHomepage.css";
import UserAnalyticsContentComponent from "../../containers/logged_user_components/user_analytics/user_analytics_content_component/user_analytics_content_component";
import UserBookmarksContentComponent from "../../containers/logged_user_components/user_bookmarks/user_bookmarks_content_component/user_bookmarks_content_component";
import NotificationListPanel from "../notifications/NotificationListPanel";
import MySpaceReferAndEarn from "./ReferAndEarn/MySpaceReferAndEarn";
import WalletContentComponent from "../../containers/logged_user_components/Wallet/WalletComponent/WalletContentComponent/WalletContentComponent";
import ScheduleClass from "../../containers/logged_user_components/user_dashboard/user_dashboard_content_component/dashboard_utlility_components/schedule_class/schedule_class";
import HomeWorkContent from "../../containers/logged_user_components/user_exercise_test/user_homework/HomeWorkContent";

const Bone = ({ className = "" }) => (
  <span className={`my-space-skeleton__bone ${className}`.trim()} />
);

const MySpacePageSkeleton = () => (
  <div
    className="my-space-skeleton"
    role="status"
    aria-live="polite"
    aria-busy="true"
    aria-label="Loading My Space"
  >
    <div className="my-space-skeleton__header">
      <Bone className="my-space-skeleton__back" />
      <Bone className="my-space-skeleton__title" />
      <div className="my-space-skeleton__header-actions">
        <Bone className="my-space-skeleton__chip" />
        <Bone className="my-space-skeleton__chip my-space-skeleton__chip--short" />
        <Bone className="my-space-skeleton__link" />
      </div>
    </div>

    <div className="my-space-skeleton__profile">
      <div className="my-space-skeleton__identity">
        <Bone className="my-space-skeleton__avatar" />
        <div className="my-space-skeleton__identity-copy">
          <Bone className="my-space-skeleton__name" />
          <Bone className="my-space-skeleton__subtitle" />
          <Bone className="my-space-skeleton__badge" />
        </div>
      </div>
      <div className="my-space-skeleton__stats">
        <div className="my-space-skeleton__stat">
          <Bone className="my-space-skeleton__stat-label" />
          <Bone className="my-space-skeleton__stat-value" />
        </div>
        <div className="my-space-skeleton__stat">
          <Bone className="my-space-skeleton__stat-label" />
          <Bone className="my-space-skeleton__stat-value" />
        </div>
      </div>
    </div>

    <div className="my-space-skeleton__tabs">
      {Array.from({ length: 8 }).map((_, index) => (
        <Bone className="my-space-skeleton__tab" key={index} />
      ))}
    </div>

    <div className="my-space-skeleton__grid">
      <div className="my-space-skeleton__left">
        <div className="my-space-skeleton__card">
          <div className="my-space-skeleton__card-head">
            <Bone className="my-space-skeleton__label" />
            <Bone className="my-space-skeleton__action" />
          </div>
          <Bone className="my-space-skeleton__goal" />
          <Bone className="my-space-skeleton__line" />
          <Bone className="my-space-skeleton__bar" />
          <Bone className="my-space-skeleton__line my-space-skeleton__line--short" />
          <Bone className="my-space-skeleton__pill" />
        </div>
        <div className="my-space-skeleton__card">
          <div className="my-space-skeleton__card-head">
            <Bone className="my-space-skeleton__streak-title" />
            <Bone className="my-space-skeleton__icon" />
          </div>
          <Bone className="my-space-skeleton__label" />
          <div className="my-space-skeleton__week">
            {Array.from({ length: 7 }).map((_, index) => (
              <Bone className="my-space-skeleton__day" key={index} />
            ))}
          </div>
        </div>
      </div>
      <div className="my-space-skeleton__card my-space-skeleton__league">
        <div className="my-space-skeleton__league-top">
          <Bone className="my-space-skeleton__league-badge" />
          <div className="my-space-skeleton__league-copy">
            <Bone className="my-space-skeleton__label" />
            <Bone className="my-space-skeleton__league-name" />
          </div>
          <Bone className="my-space-skeleton__points" />
        </div>
        <div className="my-space-skeleton__steps">
          {Array.from({ length: 4 }).map((_, index) => (
            <Bone className="my-space-skeleton__step" key={index} />
          ))}
        </div>
        <Bone className="my-space-skeleton__line" />
        <Bone className="my-space-skeleton__button" />
      </div>
    </div>
  </div>
);

export default function MySpace(props) {
  const history = useHistory();
  const location = useLocation();
  const userData = useSelector((state) => state.auth.user);
  const userPreference = useSelector((state) => state.userPreference);
  const authToken = useSelector((state) => state.auth.authToken);
  const tokenType = useSelector((state) => state.auth.tokenType);

  const [progressData, setProgressData] = React.useState(null);
  const [isXpInfoOpen, setIsXpInfoOpen] = React.useState(false);
  const [isDailyGoalModalOpen, setIsDailyGoalModalOpen] = React.useState(false);
  const [dailyGoalData, setDailyGoalData] = React.useState(null);
  const [activeTab, setActiveTab] = React.useState("engage");
  const [userGetData, setUserGetData] = React.useState(null);
  const [progressLoading, setProgressLoading] = React.useState(true);
  const [userMetaLoading, setUserMetaLoading] = React.useState(() =>
    Boolean(String(authToken || "").trim())
  );

  React.useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const response = await axios.get(url_293);
        if (!cancelled && response?.data?.status === 200) {
          setProgressData(response.data.data);
        }
      } finally {
        if (!cancelled) setProgressLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  React.useEffect(() => {
    if (!String(authToken || "").trim()) {
      setUserGetData(null);
      setUserMetaLoading(false);
      return;
    }
    let cancelled = false;
    setUserMetaLoading(true);
    const headers = { Authorization: `${tokenType} ${authToken}` };
    (async () => {
      try {
        const response = await axios.get(url_8, { headers });
        if (cancelled) return;
        if (response?.data?.status === 200 && response?.data?.data) {
          setUserGetData(response.data.data);
        } else {
          setUserGetData(null);
        }
      } catch {
        if (!cancelled) setUserGetData(null);
      } finally {
        if (!cancelled) setUserMetaLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [authToken, tokenType]);

  const fetchDailyGoalData = React.useCallback(async () => {
    const response = await axios.get(url_294);
    if (response?.data?.status === 200) {
      setDailyGoalData(response.data.data);
      return response.data.data;
    }
    return null;
  }, []);

  const handleOpenDailyGoalModal = React.useCallback(async () => {
    try {
      if (!dailyGoalData) {
        await fetchDailyGoalData();
      }
      setIsDailyGoalModalOpen(true);
    } catch (error) {
      console.error("Failed to fetch daily goal data:", error);
    }
  }, [dailyGoalData, fetchDailyGoalData]);

  const refreshHomepageData = React.useCallback(async () => {
    const response = await axios.get(url_293);
    if (response?.data?.status === 200) {
      setProgressData(response.data.data);
    }
  }, []);

  const subtitle = (() => {
    const pref = userPreference || {};
    const target = Array.isArray(pref.targetDetails) && pref.targetDetails[0]?.target;
    const cls = pref.classDetails?.class;
    const course = Array.isArray(pref.courseDetails) && pref.courseDetails[0]?.course;
    return [target, cls, course].filter(Boolean).join(" • ");
  })();

  const totalAttempt = progressData?.daily?.total_attempt ?? "";
  const progressPercentRaw = progressData?.daily?.progress_percent ?? "";
  const todayPoints =
    progressData?.daily?.["Points Earned Today"] ?? progressData?.daily?.xp_points;
  const xpTotal = progressData?.total_xp_point;

  const showVerifiedCheckmark = userGetData?.show_verified_tick === true;
  const profileMembershipTag = String(userGetData?.membership_tag ?? "").trim();
  const scheduleIsPaid = userGetData?.is_paid ?? userData?.is_paid ?? null;

  const isMySpaceLoading = progressLoading || userMetaLoading;

  return (
    <main className="engage-homepage-shell my-space-shell">
      <Sidebar />
      <div className="engage-homepage my-space-page">
        {isMySpaceLoading ? (
          <MySpacePageSkeleton />
        ) : (
          <>
            <div className="engage-homepage__fixed-top">
              <EngageHomepageHeader />
              <div className="engage-homepage__top">
                <EngageProfile
                  avatarSrc={userData?.image?.trim() || ""}
                  name={userData?.name?.trim() || ""}
                  subtitle={subtitle}
                  tierLabel={profileMembershipTag}
                  showCheckmarkBadge={showVerifiedCheckmark}
                  dailyGoalValue={String(totalAttempt).split(" ")[0] || ""}
                  dailyGoalSuffix="Solved"
                  xpValue={xpTotal !== undefined ? String(xpTotal) : ""}
                  xpSuffix="points"
                  onDailyGoalClick={handleOpenDailyGoalModal}
                  onInfoClick={() => setIsXpInfoOpen(true)}
                />
              </div>
              <div className="engage-homepage__tabs-wrap" role="tablist" aria-label="My Space tabs">
                <div className="engage-homepage__tabs">
                  {/* <button
                    type="button"
                    role="tab"
                    aria-selected={activeTab === "rankPredictor"}
                    className={`engage-homepage__tab ${
                      activeTab === "rankPredictor" ? "engage-homepage__tab--active" : ""
                    }`}
                    onClick={() => setActiveTab("rankPredictor")}
                  >
                    Rank Predictor
                  </button> */}
                  <button
                    type="button"
                    role="tab"
                    aria-selected={activeTab === "engage"}
                    className={`engage-homepage__tab ${
                      activeTab === "engage" ? "engage-homepage__tab--active" : ""
                    }`}
                    onClick={() => setActiveTab("engage")}
                  >
                    Engage
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={activeTab === "progress"}
                    className={`engage-homepage__tab ${
                      activeTab === "progress" ? "engage-homepage__tab--active" : ""
                    }`}
                    onClick={() => setActiveTab("progress")}
                  >
                    Progress
                  </button>
                
                  <button
                    type="button"
                    role="tab"
                    aria-selected={activeTab === "bookmarks"}
                    className={`engage-homepage__tab ${
                      activeTab === "bookmarks" ? "engage-homepage__tab--active" : ""
                    }`}
                    onClick={() => setActiveTab("bookmarks")}
                  >
                    Bookmarks
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={activeTab === "mySchedule"}
                    className={`engage-homepage__tab ${
                      activeTab === "mySchedule" ? "engage-homepage__tab--active" : ""
                    }`}
                    onClick={() => setActiveTab("mySchedule")}
                  >
                    My Schedule
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={activeTab === "homework"}
                    className={`engage-homepage__tab ${
                      activeTab === "homework" ? "engage-homepage__tab--active" : ""
                    }`}
                    onClick={() => setActiveTab("homework")}
                  >
                    Home Work
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={activeTab === "notifications"}
                    className={`engage-homepage__tab ${
                      activeTab === "notifications" ? "engage-homepage__tab--active" : ""
                    }`}
                    onClick={() => setActiveTab("notifications")}
                  >
                    Notifications
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={activeTab === "referEarn"}
                    className={`engage-homepage__tab ${
                      activeTab === "referEarn" ? "engage-homepage__tab--active" : ""
                    }`}
                    onClick={() => setActiveTab("referEarn")}
                  >
                    Refer & Earn
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={activeTab === "coins"}
                    className={`engage-homepage__tab ${
                      activeTab === "coins" ? "engage-homepage__tab--active" : ""
                    }`}
                    onClick={() => setActiveTab("coins")}
                  >
                    Coins
                  </button>
                </div>
              </div>
            </div>

            <div className="engage-homepage__scroll">
              {activeTab === "rankPredictor" && <RankPredictorHomePage />}
              {activeTab === "engage" && (
                <EngageHomepage
                  {...props}
                  totalAttempt={totalAttempt}
                  progressPercentRaw={progressPercentRaw}
                  todayPoints={todayPoints}
                  motivationMessage={progressData?.goal_footer_text ?? ""}
                  handleOpenDailyGoalModal={handleOpenDailyGoalModal}
                />
              )}
              {activeTab === "progress" && (
                <div className="my-space-progress-panel">
                  <UserAnalyticsContentComponent
                    history={history}
                    userPreference={userPreference}
                    embeddedInMySpace
                  />
                </div>
              )}
              {activeTab === "mySchedule" && (
                <div className="my-space-schedule-panel">
                  <ScheduleClass
                    history={history}
                    isPaid={scheduleIsPaid}
                    embeddedInMySpace
                  />
                </div>
              )}
              {activeTab === "homework" && (
                <div className="my-space-homework-panel">
                  <HomeWorkContent />
                </div>
              )}
              {activeTab === "bookmarks" && (
                <div className="my-space-bookmarks-panel">
                  <UserBookmarksContentComponent history={history} embeddedInMySpace />
                </div>
              )}
              {activeTab === "notifications" && (
                <div className="my-space-notifications-panel">
                  <NotificationListPanel active embeddedInMySpace heading="Notifications" />
                </div>
              )}
              {activeTab === "referEarn" && (
                <div className="my-space-refer-earn-panel">
                  <MySpaceReferAndEarn active />
                </div>
              )}
              {activeTab === "coins" && (
                <div className="my-space-coins-panel">
                  <WalletContentComponent
                    history={history}
                    userData={userData}
                    userPreference={userPreference}
                    location={location}
                    embeddedInMySpace
                  />
                </div>
              )}
            </div>
          </>
        )}
      </div>

      <XpPointsInfoModal
        isOpen={isXpInfoOpen}
        onClose={() => setIsXpInfoOpen(false)}
        popupData={progressData?.popupdata}
      />
      <DailyGoalModal
        isOpen={isDailyGoalModalOpen}
        onClose={() => setIsDailyGoalModalOpen(false)}
        dailyGoalData={dailyGoalData}
        onSaved={async () => {
          await Promise.all([refreshHomepageData(), fetchDailyGoalData()]);
        }}
      />
    </main>
  );
}
